<template>
	<div>
		<el-dialog title="选择工艺参数组" :visible.sync="visible" :before-close="beforClose" width="30%">
			<el-table :data="data" size="small" height="500px">
				<el-table-column prop="name" label="工艺参数组名"></el-table-column>
				<el-table-column label="操作" width="150">
					<template slot-scope="scope">
						<el-link @click="view(scope.row)" icon="el-icon-view">查看</el-link>
						<span class="line">|</span>
						<el-link @click="set(scope.row)" icon="el-icon-edit">设置</el-link>
					</template>
				</el-table-column>
			</el-table>
		</el-dialog>
		<teach-group-detail :show="showDetail" :teachGroupId="selectedTeachGroupId" v-on:close="detailDialogClose" />
	</div>
</template>

<script>
	import * as teachGroupRequest from '@/network/requests/techGroup'
	import TeachGroupDetail from './TeachGroupDetailDialog'
	export default {
		components: {
			TeachGroupDetail,
		},
		props: {
			show: {
				type: Boolean,
			},
		},
		data() {
			return {
				data: [],
				pageSize: 10,
				pageIndex: 1,
				pageCount: 0,
				visible: false,
				showDetail: false,
				selectedTeachGroupId: '',
			}
		},
		watch: {
			show(val) {
				this.visible = val
				console.log(this.data)
			},
		},
		methods: {
			/**
			 * 获取参数组。
			 */
			getTeachGroups() {
				teachGroupRequest.queryTechGroups(1, 100, '').then(({ data }) => {
					this.data = data._embedded
					this.pageCount = data._total_pages
				})
			},
			/**
			 * 设置参数组。
			 */
			set(row) {
				this.$emit('setTeachGroup', {
					id: row._id.$oid,
					name: row.name,
				})
				this.$emit('close')
			},
			/**
			 * 查看参数信息。
			 */
			view(row) {
				this.selectedTeachGroupId = row._id.$oid
				this.showDetail = true
			},
			/**
			 * 关闭
			 */
			beforClose(done) {
				this.$emit('close')
				done()
			},
			detailDialogClose() {
				this.showDetail = false
			},
		},
		created() {
			this.getTeachGroups()
		},
	}
</script>

<style></style>
